import { ComponentProps } from 'react';
import styled from 'styled-components';
import { media } from '../theme/base/mixins';
import { StyledDivComponent } from '../types';
import { EmphasizedText } from './Text';
import { Title } from './Title';

interface SubtitleType {
  H1: StyledDivComponent<ComponentProps<typeof Title.H1>>;
  H2: StyledDivComponent<ComponentProps<typeof Title.H2>>;
  H3: StyledDivComponent<ComponentProps<typeof Title.H3>>;
  H4: StyledDivComponent<ComponentProps<typeof Title.H4>>;
  H5: StyledDivComponent<ComponentProps<typeof Title.H5>>;
  H6: StyledDivComponent<ComponentProps<typeof Title.H6>>;
  Card: StyledDivComponent<ComponentProps<typeof Title.Card>>;
  Quality: StyledDivComponent<ComponentProps<typeof Title.Card>>;
  SearchItem: StyledDivComponent<ComponentProps<typeof Title.WatchListItem>>;
  WatchListItem: StyledDivComponent<ComponentProps<typeof Title.WatchListItem>>;
  MapInfo: StyledDivComponent<ComponentProps<typeof Title.MapInfo>>;
  BusOffers: StyledDivComponent<ComponentProps<typeof Title.BusOffers>>;
  FormSteps: StyledDivComponent<ComponentProps<typeof Title.H3>>;
}

export const Subtitle: SubtitleType = {
  H1: Title.H1.withComponent('div').extend`
    font-size: ${(props) =>
      (props.theme.defaults.fontSize *
        props.theme.components.subtitle.h1.size) /
      1.5}rem;
    font-weight: ${(props) =>
      props.theme.components.subtitle.h1.fontWeight};
    font-style: ${(props) =>
      props.theme.components.subtitle.h1.fontStyle};
    line-height: 1.15;
    color: ${(props) => props.theme.colors.grayMedium};

    ${EmphasizedText} {
    line-height: 1.15;
    }

    ${media.large`
      font-size: ${(props) =>
        props.theme.defaults.fontSize *
        props.theme.components.subtitle.h1.size}rem;
    `}
  `,
  H2: Title.H2.withComponent('div').extend`
    font-size: ${(props) =>
      (props.theme.defaults.fontSize *
        props.theme.components.subtitle.h2.size) /
      1.5}rem;
    font-weight: ${(props) =>
      props.theme.components.subtitle.h2.fontWeight};
    font-style: ${(props) =>
      props.theme.components.subtitle.h2.fontStyle};
    line-height: 1.15;
    color: ${(props) => props.theme.colors.grayMedium};

    ${EmphasizedText} {
      line-height: 1.15;
    }

    ${media.large`
      font-size: ${(props) =>
        props.theme.defaults.fontSize *
        props.theme.components.subtitle.h2.size}rem;
    `}
  `,
  H3: Title.H3.withComponent('div').extend`
    font-size: ${(props) =>
      (props.theme.defaults.fontSize *
        props.theme.components.subtitle.h3.size) /
      1.5}rem;
    font-weight: ${(props) =>
      props.theme.components.subtitle.h3.fontWeight};
    font-style: ${(props) =>
      props.theme.components.subtitle.h3.fontStyle};
    line-height: 1.15;
    color: ${(props) => props.theme.colors.grayMedium};

    ${EmphasizedText} {
      line-height: 1.15;
    }

    ${media.large`
      font-size: ${(props) =>
        props.theme.defaults.fontSize *
        props.theme.components.subtitle.h3.size}rem;
    `}
  `,
  H4: Title.H4.withComponent('div').extend`
    font-size: ${(props) =>
      props.theme.defaults.fontSize *
      props.theme.components.subtitle.h4.size}rem;
    font-weight: ${(props) =>
      props.theme.components.subtitle.h4.fontWeight};
    font-style: ${(props) =>
      props.theme.components.subtitle.h4.fontStyle};
    line-height: ${(props) =>
      props.theme.components.subtitle.h4.lineHeight}rem;
    color: ${(props) => props.theme.colors.grayMedium};

    ${EmphasizedText} {
      line-height: ${(props) =>
        props.theme.components.subtitle.h4.lineHeight}rem;
    }
  `,
  H5: Title.H5.withComponent('div').extend`
    font-size: ${(props) =>
      props.theme.defaults.fontSize *
      props.theme.components.subtitle.h5.size}rem;
    font-weight: ${(props) =>
      props.theme.components.subtitle.h5.fontWeight};
    font-style: ${(props) =>
      props.theme.components.subtitle.h5.fontStyle};
    line-height: ${(props) =>
      props.theme.components.subtitle.h5.lineHeight}rem;
    color: ${(props) => props.theme.colors.grayMedium};
    margin-bottom: 10px;

    ${EmphasizedText} {
      line-height: ${(props) =>
        props.theme.components.subtitle.h5.lineHeight}rem;
    }
  `,
  H6: Title.H6.withComponent('div').extend`
    font-size: ${(props) =>
      props.theme.defaults.fontSize *
      props.theme.components.subtitle.h6.size}rem;
    font-weight: ${(props) =>
      props.theme.components.subtitle.h6.fontWeight};
    font-style: ${(props) =>
      props.theme.components.subtitle.h6.fontStyle};
    line-height: ${(props) =>
      props.theme.components.subtitle.h6.lineHeight}rem;
    color: ${(props) => props.theme.colors.grayMedium};

    ${EmphasizedText} {
      line-height: ${(props) =>
        props.theme.components.subtitle.h6.lineHeight}rem;
    }
  `,
  Card: Title.Card.withComponent('div').extend`
    font-size: ${(props) =>
      props.theme.defaults.fontSize *
      props.theme.components.subtitle.card.size}rem;
    font-weight: ${(props) =>
      props.theme.components.subtitle.card.fontWeight};
    font-style: ${(props) =>
      props.theme.components.subtitle.card.fontStyle};
    line-height: ${(props) =>
      props.theme.components.subtitle.card.lineHeight}rem;
    color: ${(props) => props.theme.colors.black};

    ${EmphasizedText} {
      line-height: ${(props) =>
        props.theme.components.subtitle.card.lineHeight}rem;
    }

    ${media.large`
      font-size: ${(props) =>
        props.theme.defaults.fontSize *
        props.theme.components.subtitle.card.size}rem;
    `}
  `,
  Quality: Title.Card.withComponent('div').extend`
    font-size: ${(props) =>
      props.theme.defaults.fontSize *
      props.theme.components.subtitle.quality.size}rem;
    font-weight: ${(props) =>
      props.theme.components.subtitle.quality.fontWeight};
    font-style: ${(props) =>
      props.theme.components.subtitle.quality.fontStyle};
    line-height: ${(props) =>
      props.theme.components.subtitle.quality.lineHeight}rem;
    color: ${(props) => props.theme.colors.grayMedium};

    ${EmphasizedText} {
      line-height: ${(props) =>
        props.theme.components.subtitle.quality.lineHeight}rem;
    }

    ${media.large`
      font-size: ${(props) =>
        props.theme.defaults.fontSize *
        props.theme.components.subtitle.quality.size}rem;
    `}
  `,
  SearchItem: Title.WatchListItem.withComponent('div').extend`
    margin-bottom: 20px;
  `,
  WatchListItem: Title.WatchListItem.withComponent('div').extend`
    margin-bottom: 15px;
  `,
  MapInfo: Title.MapInfo.withComponent('div').extend`
    font-size: ${(props) =>
      (props.theme.defaults.fontSize *
        props.theme.components.subtitle.mapInfo.size) /
      1.5}rem;
    font-weight: ${(props) =>
      props.theme.components.subtitle.mapInfo.fontWeight};
    font-style: ${(props) =>
      props.theme.components.subtitle.mapInfo.fontStyle};
    line-height: 1.15;
    color: ${(props) => props.theme.colors.grayMedium};
    margin-bottom: 20px;

    * {
      line-height: 1.15;
    }

    ${media.medium`
      font-size: ${(props) =>
        props.theme.defaults.fontSize *
        props.theme.components.subtitle.mapInfo.size}rem;
      margin-bottom: 30px;
    `}
  `,
  BusOffers: styled(Title.BusOffers.withComponent('div'))`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  FormSteps: Title.H3.withComponent('div').extend`
    font-style: normal;
    font-weight: 500;
    font-size: 3.2rem;
    margin-bottom: 20px;

    ${media.large`
      font-size: 3.2rem;
    `}
  `
};
